<template>
    <Accordion class="pl-2 pr-2 space-y-2 bg-opacity-30 bg-slate-400" title="Connection">
        <PropertyRow label="From">
            <select class="connection-select" :value="node.from" @change="setProperty('from', $event.target.value)">
                <option value="">Missing badge</option>
                <option v-for="badge in badges" :key="badge.id()" :value="badge.id()">{{ badgeLabel(badge) }}</option>
            </select>
        </PropertyRow>
        <PropertyRow label="To">
            <select class="connection-select" :value="node.to" @change="setProperty('to', $event.target.value)">
                <option value="">Missing badge</option>
                <option v-for="badge in badges" :key="badge.id()" :value="badge.id()">{{ badgeLabel(badge) }}</option>
            </select>
        </PropertyRow>
        <PropertyRow label="From side">
            <select class="connection-select" :value="node.from_side" @change="setProperty('from_side', $event.target.value)">
                <option v-for="side in sides" :key="side" :value="side">{{ side }}</option>
            </select>
        </PropertyRow>
        <PropertyRow label="To side">
            <select class="connection-select" :value="node.to_side" @change="setProperty('to_side', $event.target.value)">
                <option v-for="side in sides" :key="side" :value="side">{{ side }}</option>
            </select>
        </PropertyRow>
    </Accordion>
    <Accordion class="pl-2 pr-2 space-y-2 bg-opacity-30 bg-slate-400" title="Data">
        <form-input name="minimum" type="number" v-model.number="node.min" @input="node.adjust('min')" />
        <form-input name="maximum" type="number" v-model.number="node.max" @input="node.adjust('max')" />
        <PropertyRow label="Value source">
            <select class="connection-select" :value="node.value_source" @change="setProperty('value_source', $event.target.value)">
                <option value="own">Own value</option>
                <option value="from">From badge</option>
                <option value="to">To badge</option>
            </select>
        </PropertyRow>
        <form-input v-if="node.value_source === 'own'" name="value" type="number" v-model.number="node.value"
            @input="node.adjust('value')" />
        <form-input v-else name="value" type="number" :model-value="effectiveValue" disabled />
    </Accordion>
    <Accordion class="pl-2 pr-2 space-y-2 bg-opacity-30 bg-slate-400" title="Bullet">
        <PropertyRow label="Animation">
            <input type="checkbox" :checked="node.animation_enabled"
                @change="setProperty('animation_enabled', $event.target.checked)" />
        </PropertyRow>
        <PropertyRow label="Bullet color">
            <ColorPicker :key="editorKey('bullet_color')" :pureColor="node.bullet_color"
                useType="pure" format="hex8" lang="En" shape="circle"
                @update:pureColor="setProperty('bullet_color', $event)" />
        </PropertyRow>
        <form-input name="bullet size" type="number" min="1" v-model.number="node.bullet_size"
            @input="node.adjust('bullet_size')" />
        <form-input name="bullet count" type="number" min="1" step="1" v-model.number="node.bullet_count"
            @input="node.adjust('bullet_count')" />
        <p v-if="bulletSizeWarning" class="connection-warning">Bullet size must be smaller than connection spacing.</p>
    </Accordion>
</template>

<script>
import { ColorPicker } from 'vue3-colorpicker'
import Accordion from '../Accordion.vue'
import PropertyRow from './PropertyRow.vue'
import { getObjectPage } from '../../utils/hasputils'
import { propertyEditorKey } from './propertyEditorKey.js'

export default {
    name: 'ConnectionPropertiesEditor',
    components: { Accordion, ColorPicker, PropertyRow },
    props: { node: { type: Object, required: true } },
    data: () => ({
        sides: ['auto', 'top', 'right', 'bottom', 'left'],
    }),
    computed: {
        badges() {
            const page = getObjectPage(this.node)
            return page?.find?.(candidate => candidate.obj === 'badge') ?? []
        },
        bulletSizeWarning() {
            return Number(this.node.bullet_size) >= Number(this.node.getLayer()?.getAttr?.('connection_spacing') ?? 12)
        },
        effectiveValue() {
            return this.node.getEffectiveValue?.() ?? 0
        },
    },
    methods: {
        editorKey(context) {
            return propertyEditorKey(this.node, `connection:${context}`)
        },
        badgeLabel(badge) {
            return badge.comment || `Badge ${badge.haspid}`
        },
        setProperty(property, value) {
            this.node[property] = value
            this.node.adjust(property)
        },
    },
}
</script>

<style scoped>
.connection-select {
    width: 100%;
    height: 24px;
    padding: 0 0.25rem;
    border: 1px solid rgb(148 163 184 / 0.6);
    border-radius: 0.25rem;
    background: rgb(30 41 59 / 0.6);
    color: white;
    font-size: 0.75rem;
}
.connection-warning {
    color: rgb(253 186 116);
    font-size: 0.7rem;
}
</style>
